module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-37.1808424b.png";